import React from "react";
import UserRow from "./userRow";
import userApi from '../api/usersAPI';
import Paginate from "./paginate";
import Filters from "./filters";
import {actions, Loader} from "react-fields";
import NoUsers from "./noUsers";
import InvitationsApi from "../api/invitationsAPI";
import PopUp from "../base/popup";
import ResendPopup from "./resendPopup";
import {FadeInSection} from "../../components/fadeIn";

class Users extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            users: [],
            totalPages: 0,
            page: 1,
            usersLoaded: false,
            filter: {user_status: 'all', test_status: 'none', custom_statuses: []},
            sort: null,
            search_q: null,
            perPage: 10,
            isLoading: false,
            emailSent: ''
        };
        this.sentInvitationsRef = React.createRef();
    }



    componentDidMount() {
        this.loadUsers(1,{},() => {
            this.setState({usersLoaded: true})
        })
    }

    loadUsers = (page = 1, options = {}, callback = null) => {
        userApi.getUsers(page, options).then((response) => {
            this.setState({users: response.users, totalPages: response.meta.total_pages, totalCount: response.meta.total_count});
            if (callback) {callback.call()}
            this.setState({isLoading: false})
        }).catch(error => {
            console.log(error);
            this.setState({isLoading: false})
        });
    };

    gotToPage = (page) => {
       this.setState({page: page}, () => {
           this.loadUsers(page, {filter: this.state.filter, sort: this.state.sort,
               search_q: this.state.search_q, per_page: this.state.perPage});
       })
    };

    filterUsers = (filter) => {
      this.setState({filter: filter, isLoading: true}, () => {
          this.loadUsers(1, {filter: filter, sort: this.state.sort,
              search_q: this.state.search_q, per_page: this.state.perPage});
      })
    };

    sort = (field) => {
        this.setState({sort: field, isLoading: true}, () => {
            this.loadUsers(1, {filter: this.state.filter, sort: field,
                search_q: this.state.search_q, per_page: this.state.perPage});
        });
    };

    search = (q) => {
        this.setState({search_q: q, isLoading: true}, () => {
            this.loadUsers(1, {filter: this.state.filter, sort: this.state.sort, search_q: q, per_page: this.state.perPage});
        });
    };

    generateExportLink = () => {
        let path = '/group/api/users/export';
        let options= this.state.filter;
        if (this.state.sort) { options.sort = this.state.sort}
        if (this.state.search_q) { options.q = this.state.search_q}
        return`${path}?${actions.paramsToURI(options)}`;
    };

    resendInvitation = (user) => {
        this.setState({isLoading: true}, () => {
            InvitationsApi.resend(user.id).then((response) => {
                this.setState({emailSent: user.email});
                this.sentInvitationsRef.current.open();
                this.setState({isLoading: false})
            }).catch(error => {
                console.log(error);
                this.setState({isLoading: false})
            });
        })

    };

    deleteUser = (userId) => {
        userApi.deleteUser(userId).then((response) => {
            this.loadUsers();
        }).catch(error => {
            console.log(error);
        });
    };

    onChangePerPage = (e) => {
        let perPage = e.target.value;
        this.setState({perPage: perPage}, () => {
            this.loadUsers(1, {per_page: perPage});
        })
    };


    render() {
        return  (
            <FadeInSection>
                <div>
                    {this.state.isLoading ? <Loader /> : null}
                    <Filters filter={this.state.filter} onChnange={this.filterUsers} search={this.search} exportLink={this.generateExportLink()} {...this.props}/>
                    <div className="grid-x">
                        <div className="small-12 cell">
                            <div className="users__table-container">
                                <table className={`users__table ${this.state.usersLoaded && !this.state.users.length ? 'is-empty' : '' }`}>
                                    <thead>
                                    <tr>
                                        <th>
                                            <div className="users__sort" onClick={() => this.sort(this.state.sort === 'name_desc' ? 'name_asc' : 'name_desc')}><p>User</p><span
                                                className={`small-icon chevron-down ${this.state.sort === 'name_asc' ? 'chevron-down--up' : ''}`}/></div>
                                        </th>
                                        <th>
                                            <div className="users__sort" onClick={() => this.sort(this.state.sort === 'email_desc' ? 'email_asc' : 'email_desc')}><p>Email address</p><span
                                                className={`small-icon chevron-down ${this.state.sort === 'email_asc' ? 'chevron-down--up' : ''}`}/></div>
                                        </th>
                                        <th><p>Status</p></th>
                                        {this.props.full_access || this.props.interests_access ? <th className="users__table--small"><p>Career Interests</p></th> : null}
                                        {this.props.full_access || this.props.personality_access ? <th className="users__table--small"><p>Work Personality</p></th> : null}
                                        {this.props.full_access || this.props.motivators_access ? <th className="users__table--small"><p>Career Motivators</p></th> : null}
                                        {this.props.full_access || this.props.abstract_access ? <th className="users__table--small"><p>Abstract Reasoning</p></th> : null}
                                        {this.props.full_access || this.props.verbal_access ? <th className="users__table--small"><p>Verbal Reasoning</p></th> : null}
                                        {this.props.full_access || this.props.numerical_access ? <th className="users__table--small"><p>Numerical Reasoning</p></th> : null}
                                        <th colSpan="4"/>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.usersLoaded && !this.state.users.length ?
                                            <NoUsers/>
                                            :
                                            this.state.users.map((user) => {
                                            return <UserRow user={user} key={user.id} resend={this.resendInvitation} onDelete={this.deleteUser} {...this.props} />;
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>


                    {this.state.totalPages > 1 ? <Paginate page={this.state.page}
                                                           onChangePerPage={this.onChangePerPage}
                                                           perPage={this.state.perPage}
                                                           totalPages={this.state.totalPages}
                                                           totalCount={this.state.totalCount}
                                                           count={this.state.users.length}
                                                           gotToPage={this.gotToPage}/> : null}
                    <PopUp ref={this.sentInvitationsRef} onClose={() => {}}>
                        <ResendPopup email={this.state.emailSent}/>
                    </PopUp>

                </div>
            </FadeInSection>
        )
    }
}
export default Users;